import { useState, useEffect } from "react";
import Banner from './Banner/Banner';
import Pioneer from './Pioneer/Pioneer';
import Evolve from './Evolve/Evolve';
import Header from '../landing/Header/Header';
import Footer from '../landing/footer/Footer';
import Mobilebanner from './Banner/Mobilebanner';
import '../Homepage/Banner/banner.scss'
import { useLocation, useNavigate } from "react-router-dom";

const Homepage = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500); 
  
    return () => clearTimeout(timer);
  }, []);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has("isApp")) {
      navigate("/", { replace: true });
    }
  }, [location, navigate]);

    useEffect(() => {
    if (window.location.hash === "#!/product.asp") {
      navigate("/", { replace: true }); 
    }
  }, [navigate]);

  useEffect(() => {
    const handleHashRedirect = () => {
      if (window.location.hash === "#!/product.asp") {
        navigate("/", { replace: true });
      }
    };

    
    handleHashRedirect();

    window.addEventListener("hashchange", handleHashRedirect);

    return () => {
      window.removeEventListener("hashchange", handleHashRedirect);
    };
  }, [navigate]);


 



  return (
    <>
    <div className="homepagemain">
      <Header />
      {isMobile ? <Mobilebanner /> : <Banner />}
      <Pioneer />
      <Evolve />
      <Footer />
      </div>
    </>
  );
};

export default Homepage;
